import { login as loginRequest } from 'repositories/user.repository';

export const SET_TOKEN = '[Admin] SET_TOKEN';
export const setToken = (payload) => ({
  type: SET_TOKEN,
  payload,
});

export const LOGIN = '[Admin] LOGIN';
export const login = (email, password) => (dispatch) => loginRequest(email, password)
  .then((response) => response.data)
  .then((data) => `Bearer ${data.token}`)
  .then((token) => dispatch(setToken(token)));

